export function configureCurrencyFormat($locale) {
    'ngInject'
    const patterns = $locale.NUMBER_FORMATS.PATTERNS[1];
    patterns.negPre = '(\u00a4';
    patterns.negSuf = ')';
}
